export const breadcrumbs = [
  {
    text: "Главная",
    disabled: false,
    href: "/",
  },
  {
    text: "Учет: Реестр МЧД",
    disabled: true,
    href: "breadcrumbs_link_1",
  },
];
